export default "__VITE_ASSET__502a766b__"